import { Tooltip } from "../Tooltip/Tooltip.js";
import Switch_module_default from "./Switch.module.js";
import classNames from "classnames";
import { useCallback } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Switch/Switch.tsx
var Switch = ({ name, leftIcon: LeftIcon, leftLabel, leftValue, rightIcon: RightIcon, rightLabel, rightValue, value, className, onChange, size = "lg", ...fieldSetProps }) => {
	const onInputChange = useCallback((e) => onChange(e.target.value), [onChange]);
	return /* @__PURE__ */ jsxs("fieldset", {
		"data-size": size,
		className: classNames(Switch_module_default.toggle, className),
		...fieldSetProps,
		children: [
			/* @__PURE__ */ jsx(Tooltip, {
				label: leftLabel,
				children: /* @__PURE__ */ jsx("input", {
					type: "radio",
					name,
					value: leftValue,
					checked: value === leftValue,
					onChange: onInputChange
				})
			}),
			/* @__PURE__ */ jsx(LeftIcon, { "aria-hidden": true }),
			/* @__PURE__ */ jsx(Tooltip, {
				label: rightLabel,
				children: /* @__PURE__ */ jsx("input", {
					type: "radio",
					name,
					value: rightValue,
					checked: value === rightValue,
					onChange: onInputChange
				})
			}),
			/* @__PURE__ */ jsx(RightIcon, { "aria-hidden": true })
		]
	});
};
//#endregion
export { Switch };

//# sourceMappingURL=Switch.js.map